// extracted by mini-css-extract-plugin
module.exports = {"small_statistics_container":"SmallCharts_small_statistics_container__1F6fp","button_switch":"SmallCharts_button_switch__2icjz","active":"SmallCharts_active__1Vt-K"};